/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: "2f189308-3bed-45d4-b52e-05c11f74e6ea",
        // Use tenant ID (with subdomain) for single tenant applications
        authority: "https://login.microsoftonline.com/organizations", // authority: "https://login.microsoftonline.com/564b7b99-6149-4bb9-8635-d7eb9f95bf11",
        // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        redirectUri: "https://apps.iliona.cloud",
        // Indicates the page to navigate after logout.
        postLogoutRedirectUri: "/",
        // If "true", will navigate back to the original request location before processing the auth code response.
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                const isLoggingEnabled = true;

                if (!isLoggingEnabled) {
                    return;
                }

                if (containsPii) {
                    return;
                }

                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                }
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Error
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["api://2f189308-3bed-45d4-b52e-05c11f74e6ea/User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphProfileEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"

};